// extracted by mini-css-extract-plugin
module.exports = {"header":"NewsDetailContainer_header__DBf+T","container":"NewsDetailContainer_container__SY6oL"};